export const BUILD_ID_KEY = 'mantraz_build_id';

// build id beda dari yang tersimpan (termasuk belum pernah tersimpan) + ada sesi -> maksa relogin
export function needsRelogin({ currentBuildId, storedBuildId, hasSession }) {
  if (!currentBuildId || !hasSession) return false;
  return storedBuildId !== currentBuildId;
}
